import { AgendaForm } from '../components/agenda/AgendaForm';
import { Footer } from '../components/Footer';
import { Banner } from '../components/header/Banner';
import { Loader } from '../components/Loader';
import { Menu } from '../components/menu/Menu';
import { SpeakerList } from '../components/speaker/SpeakerList';
import { Tab } from '../components/Tab';
import { Video } from '../components/video/Video';
import { useCancelDialog } from '../hooks/useCancelDialog';
import useEventStore from '../stores/eventStore';

export const Home = () => {
  const { loading } = useCancelDialog();
  const { activeTab } = useEventStore();

  return (
    <>
      {loading && <Loader />}
      <header>
        <Banner></Banner>
      </header>
      <section>
        <Tab />
      </section>
      <section>
        <AgendaForm />
      </section>
      <section>
        <SpeakerList />
      </section>
      <section>
        <Video />
      </section>
      {/* <section>
        <RegisterForm />
      </section> */}
      <Footer />
      {/* <FloatingButton /> */}
      <Menu />
    </>
  );
};
